import { render, staticRenderFns } from "./FlowOverview.vue?vue&type=template&id=2834c792&scoped=true"
import script from "./FlowOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./FlowOverview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FlowOverview.vue?vue&type=style&index=0&id=2834c792&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2834c792",
  null
  
)

export default component.exports